<template>
    <div class="toolbox">
        <div class="menu-wrap" title="新建">
            <div class="menu-item menu-new" title="新建" @click="newFile"></div>
        </div>
        <div class="menu-wrap" title="打开">
            <div class="menu-item menu-open" title="打开" @click="openFile"></div>
        </div>
        <div class="menu-wrap" title="保存">
            <div class="menu-item menu-save" title="保存" @click="saveFile"></div>
        </div>
        <div class="menu-wrap" title="打印">
            <div class="menu-item menu-print" title="打印" @click="print"></div>
        </div>
        <div class="menu-wrap" title="撤销">
            <div class="menu-item menu-lrotate" title="撤销" @click="undo"></div>
        </div>
        <div class="menu-wrap" title="恢复">
            <div class="menu-item menu-rrotate" title="恢复" @click="redo"></div>
        </div>
        <div class="menu-wrap" title="放大">
            <div class="menu-item menu-zoomout" title="放大" @click="zoomOut"></div>
        </div>
        <div class="menu-wrap" title="缩小">
            <div class="menu-item menu-zoomin" title="缩小" @click="zoomIn"></div>
        </div>
        <div class="menu-wrap" title="剪切">
            <div :class="{'menu-item':true,'menu-cut-active':true,'disactive':curFeature?false:true}" title="剪切" @click="cut"></div>
        </div>
        <div class="menu-wrap" title="粘贴">
            <div :class="{'menu-item':true,'menu-paste-active':true,'disactive':copyData&&copyData.length>0?false:true}" title="粘贴" @click="paste"></div>
        </div>
        <div class="menu-wrap" title="复制">
            <div :class="{'menu-item':true,'menu-copy-active':true,'disactive':curFeature?false:true}" title="复制" @click="copy"></div>
        </div>

        <div class="menu-wrap" title="向左旋转" @click="rotateCompontent('counterclockwise')">
            <div :class="{'menu-item menu-back-active':true, 'disactive':curFeatures.length!=1}" title="向左旋转"></div>
        </div>
        <div class="menu-wrap" title="向右旋转" @click="rotateCompontent('clockwise')">
            <div :class="{'menu-item menu-go-active':true, 'disactive':curFeatures.length!=1}" title="向右旋转"></div>
        </div>
         <div class="menu-wrap" title="删除" @click="delected">
            <div :class="{'menu-item':true,'menu-delete-active':true,'disactive':curFeature?false:true}" title="删除"></div>
        </div>
        <div class="menu-wrap" title="框选">
            <div class="menu-item menu-frame" title="框选" @click="boxSelect"></div>
        </div>
        <div class="menu-wrap" title="全屏">
            <div class="menu-item menu-full" title="全屏" @click="full"></div>
        </div>
        <div class="menu-wrap" title="表格">
            <div class="menu-item menu-table" title="表格" @click="tableData"></div>
        </div>
        <div class="menu-wrap" title="计算">
            <div class="menu-item menu-calculate" title="计算" @click="calculate"></div>
        </div>
    
        <!--类型选择-->
        <div class="menu-wrap simulation-type">
            <el-radio-group v-model="mediuType" @change="typeChangeHandle">
                <el-radio label="steam">蒸汽</el-radio>
                <el-radio label="water">水</el-radio>
                <el-radio label="insulationWater">保温水</el-radio>
                <el-radio label="compressed">压缩空气</el-radio>
            </el-radio-group>
        </div>

        <!--管道数据编辑-->
        <el-dialog
            :visible.sync="table_dialog"
            :append-to-body="true"
            :modal="false"
            custom-class="custom-dialog"
            :close-on-click-modal="false"
            v-drag>
                <span slot="title">管道编辑</span>
                <pipetable v-if="table_dialog"></pipetable>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import {DragBox, Select,DragPan,DragZoom} from 'ol/interaction';
import MouserInteraction from './PipeEditor/MouserInteraction';
import {createEmpty,extend} from 'ol/extent';
import {always} from 'ol/events/condition';

import Drag from "./PipeEditor/Drag"

export default {
    name:"toolbox",
    computed:{
        ...mapState('simulation',[
            'map',
            'drawSource',
            'copyData', // 拷贝数据
            'isCut', // 是否是剪切
            'simutype', // 仿真计算的介质类型
            "curFeatures", // 当前选中的要素
            'mapMode', // 地图模式
        ]),
        // 当前选中的Feature
        curFeature(){
            return this.$store.state.simulation.curFeatures[0];
        },
    },
    components:{
        pipetable:()=>import("./Editor/PipeTable.vue"), // 管道编辑
    },
    data(){
        return{
            dragBoxInteraction:null, // 框选交互
            dragPanInteration:null, // 拖动地图
            dragZoomInteration:null, // 绘制放大
            dragInteration:null, // 拖动要素
            mouserInteraction:null, // 鼠标事件
            selectInteration:null, // 选择地图
            layerSource:null, // 图层资源

            mediuType:"steam", // 介质类型

            table_dialog:false, // 图形编辑
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.init();
        })
    },
    watch:{
        // 仿真介质类型切换
        simutype(newType){
            this.mediuType=newType;
        }
    },
    methods:{
        // 初始化组件
        init_interactions(){
            let interactions=this.map.getInteractions();
            interactions.forEach(item=>{
                // 拖动
                if(item instanceof DragPan){
                    this.dragPanInteration=item;
                }
                // 选择交互
                if(item instanceof Select){
                    this.selectInteration=item;
                }
                // 放大
                if(item instanceof DragZoom){
                    this.dragZoomInteration=item;
                }
                // 放大
                if(item instanceof Drag){
                    this.dragInteration=item;
                }
                // 鼠标事件
                if(item instanceof MouserInteraction){
                    this.mouserInteraction=item;
                }
            });
            if(this.dragZoomInteration){
                let dragZoomInteration=new DragZoom({
                    condition:always,
                    out: true, // 此处为设置拉框完成时放大还是缩小 true缩小
                });
                this.map.addInteraction(dragZoomInteration);
                dragZoomInteration.setActive(false);
                // 绘制开始之前
                dragZoomInteration.on("boxstart",e=>{
                    // 拖动
                    this.dragPanInteration.setActive(false);
                });
                dragZoomInteration.on("boxend",e=>{
                    // 拖动
                    this.dragPanInteration.setActive(true);
                    this.dragZoomInteration.setActive(false);
                });

                this.dragZoomInteration=dragZoomInteration;
                
            }
        },
        // 初始化
        init(){
            // 获取地图拖动交互事件
            this.init_interactions();
            // 获取图层资源
            this.layerSource=this.drawSource;

            // 框选交互
            const dragBox = new DragBox({
                className:"dragbox",
            });
            this.map.addInteraction(dragBox);
            this.dragBoxInteraction=dragBox;
            let that=this;
            dragBox.on('boxend', (e)=> {
                // 获取选中内容
                if(!this.selectInteration){
                    this.init_interactions();
                }
                let selectArr=this.selectInteration.getFeatures();
                selectArr.clear();
                const extent = dragBox.getGeometry().getExtent();
                let selectFeatures=[];
                this.layerSource.forEachFeatureIntersectingExtent(extent, function (feature) {
                    // 保存选中要素
                    selectFeatures.push(feature);
                    // 显示选中状态
                    selectArr.push(feature);
                });
                // 触发选中多个
                this.$store.commit("simulation/setCurFeatures",selectFeatures);
                 // 取消框选
                dragBox.setActive(false);
                // 鼠标事件,恢复地图状态
                this.mouserInteraction.mapRestore();
            });

            // clear selection when drawing a new box and when clicking on the map
            dragBox.on('boxstart', ()=> {
                // 清空选中
                if(!this.selectInteration){
                    this.init_interactions();
                }
                let selectArr=this.selectInteration.getFeatures();
                selectArr.clear();
            });
            // 禁用框选
            dragBox.setActive(false);

        },
        // 框选
        boxSelect(){
            if(this.mapMode=='draw'){
                            // 禁止拖动地图
                this.dragPanInteration.setActive(false);
                // 启用框选
                this.dragBoxInteraction.setActive(true);
            }

        },
        // 复制
        copy(){
            this.$bus.$emit("copy");
        },
        // 剪切
        cut(){
            this.$bus.$emit("cut");
        },
        // 粘贴
        paste(){
            this.$bus.$emit("paste");
        },
        // 删除
        delected(){
            this.$bus.$emit("delected");
        },
        // 打开文件
        openFile(){
            this.$bus.$emit("uploadFile"); // 打开文件
        },
        // 新键文件
        newFile(){
            this.$bus.$emit("newFile");
        },
        // 保存文件
        saveFile(){
            this.$bus.$emit("saveFile");
        },
        // 旋转
        rotateCompontent(direction){
            if(direction=='counterclockwise'){
                this.$bus.$emit("rotate",'counterclockwise');
            }else{
                this.$bus.$emit("rotate",'clockwise');
            }
        },
        // 放大
        zoomOut(){
            this.dragZoomInteration.setActive(true);
            this.dragZoomInteration.out_=true;
        },
        // 缩小
        zoomIn(){
            this.dragZoomInteration.setActive(true);
            this.dragZoomInteration.out_=false;
        },
        // 打印
        print(){
            this.$bus.$emit("print");
        },

        // 撤销
        undo(){
            this.$store.commit("simulation/undo");  
        },
        // 重做
        redo(){
            this.$store.commit("simulation/redo");
        },

        // 仿真类型改变
        typeChangeHandle(val){
            this.$store.commit("simulation/setSimutype",val);
        },
        // 全屏
        full(){
            let features=this.drawSource.getFeatures();
            if(features.length>0){
                let ex=createEmpty();
                features.forEach(f=>{
                    let geom=f.getGeometry();
                    let tempEx=geom.getExtent();
                    ex=extend(ex,tempEx);
                });
                this.map.getView().fit(ex,{
                    padding:[40,40,40,40],
                });
            }
        
        },
        // 仿真计算
        calculate(){
            // 触发仿真事件
            this.$bus.$emit("simulate");
        },
        // 管道表格
        tableData(){
            this.table_dialog=true;
        }
    }
}
</script>

<style lang="scss" scoped>
.toolbox{
    padding:5px 15px;
    border-bottom: 1px solid rgba(58, 84, 100, 0.1);
    background-position: 0 0;
    display: flex;

    .menu-wrap{
        display: inline-block;
        cursor: pointer;
        border-radius: 2px;
        padding: 5px;
        border:1px solid #fff;
        text-align: center;
    }
    .menu-wrap:hover{
        border:1px solid rgb(101, 192, 245);
        color:#fff;
    }

    .menu-item{
        background: url('../assets/simulation/toolbar.png') no-repeat;
        width: 24px;
        height: 24px;
        background-position: 0 0;
    }

    .menu-new{
        width: 20px;
        background-position: 0 0;
    }
    .menu-open{
        background-position: -38px 0;
    }
    .menu-save{
        background-position: -82px 0;
    }
    .menu-print{
        width: 26px;
        background-position: -124px 0;
    }
    .menu-lrotate{
        background-position: -170px 0;
    }
    .menu-rrotate{
        background-position: -210px 0;
    }
    .menu-zoomout{
        background-position: -252px 0;
    }
    .menu-zoomin{
        background-position: -296px 0;
    }
    .menu-cut-active{
        background-position: -338px 0;
    }
    .menu-cut-active.disactive{
        background-position: -376px 0;
    }
    .menu-paste-active{
        width: 26;
        background-position: -418px 0;
    }
    .menu-paste-active.disactive{
        width: 26;
        background-position: -460px 0;
    }
    .menu-copy-active{
        background-position: -504px 0;
    }
    .menu-copy-active.disactive{
        background-position: -546px 0;
    }
    .menu-back-active{
        background-position: -590px 0;
    }
    .menu-back-active.disactive{
        background-position: -632px 0;
    }
    .menu-go-active{
        background-position: -674px 0;
    }
    .menu-go-active.disactive{
        background-position: -716px 0;
    }
    .menu-delete-active{
        background-position: -760px 0;
    }
    .menu-delete-active.disactive{
        background-position: -804px 0;
    }
    .menu-calculate{
        background-position: -842px 0;
    }
    // 框选
    .menu-frame{
        width: 32px;
        background-position: -924px 0;
    }
    // 全屏
    .menu-full{
        width: 26px;
        background-position: -976px 0;
    }
    // 表格
    .menu-table{
        width: 26px;
        background-position: -1020px 0;
    }
    // 停止
    .menu-stop{
        width: 26px;
        background-position: -880px 0;
    }

    // 仿真类型
    .simulation-type{
        border-radius: 4px;
        border: 1px solid #1264d6;
        line-height: 20px;
        padding: 5px 10px;
    }
}
</style>

<style lang="scss">
/** 框选的样式 */
.dragbox {
    background-color: rgba(255,255,255,0.4);
    border-color: rgba(100,150,0,1);
    border-style:dashed;
}
</style>